// src/patches/disableCookieWipe.js
// Turns cookieUtils.deleteSpecificCookies into a no-op when inside RN WebView.
// This prevents your WebView session cookies / token cookies from being wiped.

export function disableCookieWipeInWebView() {
  const inWebView =
    typeof window !== "undefined" && window.ReactNativeWebView !== undefined;

  if (!inWebView) return;

  try {
    // require at runtime to avoid import cycles
    const { cookieUtils } = require("../utils/cookie-parser");
    if (
      cookieUtils &&
      typeof cookieUtils.deleteSpecificCookies === "function"
    ) {
      cookieUtils.deleteSpecificCookies = () => {
        // no-op in WebView
        // console.log("[patch] cookie wipe disabled in WebView");
      };
    }
  } catch {
    // ignore
  }
}
